<script context="module" lang="ts">
  export interface ForumSpace {
    uuid: string;
    title: string;
    color: string;
  }
</script>

<script lang="ts">
  import StackedAvatars from "$components/+shared/StackedAvatars/StackedAvatars.svelte";
  import Avatar from "$components/+shared/Avatar/Avatar.svelte";
  import { communitySlug } from "$stores/community";
  import { threadURL } from "$utils/urls";
  import { getTimeAgo, parseDateTime } from "$utils/datetimes";
  import { slugify } from "$utils/strings";
  import type { ForumThread } from "@outverse-video/outverse-api-client-lib";
  import { track } from "app/utils/analytics";

  export let thread: ForumThread;

  const forumSpace = thread.forumSpace as unknown as ForumSpace;
  const postTime = getTimeAgo(
    parseDateTime(thread.created, "datetime is invalid")
  )?.toLocaleString();
  const lastReplyTime = getTimeAgo(
    parseDateTime(thread.lastRepliedAt, "datetime is invalid")
  )?.toLocaleString();
</script>

<a
  class="block cursor-pointer overflow-hidden rounded p-2 transition-colors hover:bg-white dark:hover:bg-white/5"
  href={threadURL({
    communitySlug: $communitySlug,
    spaceUuid: forumSpace.uuid,
    spaceSlug: slugify(forumSpace.title),
    threadUuid: thread.uuid,
    threadSlug: slugify(thread.title),
  })}
  on:click={() => track("Sidebar Semantic Relation Clicked")}
>
  <div class="flex items-center gap-1.5 text-xs">
    <Avatar
      size="size-3.5"
      radius="rounded-sm"
      mainImage={thread.author.profileImage}
      backgroundColor={thread.author.profileColor}
      label={thread.author.handle[0]}
    />
    <span class="text-gray-500 dark:text-gray-200">
      {thread.author.handle}
    </span>
    <span class="text-gray-400 dark:text-gray-400/60"> posted {postTime} </span>
  </div>

  <p class="mt-2 line-clamp-4 text-xs font-medium leading-[160%] text-gray-500 dark:text-gray-300">
    {thread.text}
  </p>

  {#if thread.repliers.length}
    <div class="mt-2 flex items-center gap-2 text-xs">
      {#if thread.repliers}
        <StackedAvatars
          size="size-3.5"
          radius="rounded-sm"
          textSize="text-[8px]"
          avatars={thread.repliers}
        />
      {/if}
      <span class="whitespace-nowrap text-blue-300">
        {thread.repliers.length}
        {thread.repliers.length > 1 ? "replies" : "reply"}
      </span>
      <!-- currently lastRepliedAt is the time of creation if no replies have been made,
           so we determine to show the time only if there are replies in the frontend  -->
      {#if thread.repliers}
        <span class="truncate text-gray-400 dark:text-gray-400/60">
          last reply {lastReplyTime}
        </span>
      {/if}
    </div>
  {/if}
</a>
